import ChatMessage from './ChatMessage';
import getEmailAddressFromSipUri from '../../presenceManager/getEmailAddressFromSipUri';
import getMySipUri from '../../presenceManager/getMySipUri';
import getRecipientDisplayName from '../selectors/getRecipientDisplayName';
import ChatMessageViewState, { ChatMessageType } from '../store/schema/ChatMessageViewState';
import { observer } from 'mobx-react-lite';
import { PersonaSize } from '@fluentui/react/lib/Persona';
import { asOwaDateInUserTz, formatUserTime } from 'owa-datetime';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import * as React from 'react';

export interface ChatMessageGroupProps {
    messages: ChatMessageViewState[];
}

const styles = require('./ChatMessageGroup.scss');
const classNames = require('classnames');

export default observer(function ChatMessageGroup(props: ChatMessageGroupProps) {
    const firstMessage = props.messages[0];
    const isSelf = getMySipUri() == firstMessage.fromSipUri;
    const groupClassname = classNames(styles.group, isSelf ? styles.self : styles.other);
    const displayName = getRecipientDisplayName(firstMessage.fromSipUri);
    const displayNameText = isSelf || !displayName ? '' : displayName + ', ';
    const timestampText =
        displayNameText + formatUserTime(asOwaDateInUserTz(new Date(firstMessage.timestamp)));
    return (
        <div className={groupClassname}>
            {!isSelf && (
                <div className={styles.personaBlock}>
                    <PersonaControl
                        emailAddress={getEmailAddressFromSipUri(firstMessage.fromSipUri)}
                        name={displayName}
                        size={PersonaSize.size32}
                    />
                </div>
            )}
            <div className={styles.messages}>
                <span className={styles.timestamp}>{timestampText}</span>
                {props.messages.map(message => (
                    <ChatMessage
                        chatMessage={message}
                        isSelf={isSelf}
                        key={generateMessageKey(message)}
                    />
                ))}
            </div>
        </div>
    );
});

export function generateMessageKey(message: ChatMessageViewState): string {
    const { messageType, sequence } = message;
    return (
        (messageType == ChatMessageType.InstantMessage ||
        messageType == ChatMessageType.InstantMessageFromToast
            ? 'i'
            : 'n') + sequence
    );
}
